import { useState } from "react";
import { useDispatch } from "react-redux";

import { IMitigation, MitigationType, setMitigationRationale } from "../../../store/playbook-analysis-slice";
import { Button } from "../ui/button";
import { Dialog, DialogClose, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "../ui/dialog";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";
import { Textarea } from "../ui/textarea";

interface ICommentEditorProps {
	comment: string;
	mitigation: IMitigation;
	mitigationIdx: number;
	keyTermIdx: number;
	type: MitigationType;
}

export function EditRationale({ comment, type, keyTermIdx, mitigationIdx }: ICommentEditorProps) {
	const dispatch = useDispatch();

	const [editorContent, setEditorContent] = useState(comment);

	function handleSave() {
		dispatch(setMitigationRationale({ type, keyTermIdx, mitigationIdx, updatedComment: editorContent }));
	}

	return (
		<Dialog>
			<Tooltip>
				<TooltipTrigger>
					<DialogTrigger>
						<Button
							variant="ghost"
							className="size-8 bg-[#f5f5f5] hover:bg-[#e6e6e6] rounded-full grid items-center justify-center"
						>
							<svg width="19" height="20" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M8.52286 4.79871C8.52286 4.79871 8.52286 5.88846 9.61261 6.97821C10.7024 8.06796 11.7921 8.06796 11.7921 8.06796M4.213 13.2496L6.50148 12.9227C6.83158 12.8755 7.13749 12.7226 7.37328 12.4868L12.8819 6.97821C13.4837 6.37636 13.4837 5.40056 12.8819 4.79871L11.7921 3.70896C11.1903 3.10711 10.2145 3.10711 9.61261 3.70896L4.10403 9.21754C3.86824 9.45333 3.71529 9.75924 3.66813 10.0893L3.3412 12.3778C3.26855 12.8864 3.70445 13.3223 4.213 13.2496Z"
									stroke="#4A88EE"
									strokeWidth="1.08333"
									strokeLinecap="round"
								/>
							</svg>
						</Button>
					</DialogTrigger>
				</TooltipTrigger>
				<TooltipContent>Edit Rationale</TooltipContent>
			</Tooltip>

			<DialogContent className="sm:max-w-[425px]">
				<DialogHeader>
					<DialogTitle>Edit Rationale</DialogTitle>
				</DialogHeader>
				<div>
					<Textarea
						value={editorContent}
						onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setEditorContent(e.target.value)}
						rows={8}
					/>
				</div>
				<DialogClose asChild>
					<Button variant="outline" onClick={handleSave}>
						Save Changes
					</Button>
				</DialogClose>
			</DialogContent>
		</Dialog>
	);
}
